import React, { useEffect, useState } from 'react';
import { IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import '../../assets/style/Notifications.css';
import { formattedDateWithFormat } from '../../utils/Util';
import { NotificationType } from '../../utils/Types';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  getTypes,
  notificationSelector,
} from '../../features/notificationSlice';
import SelectBox from '../../components/SelectBox';
import { DEFAULT_OPTION_LOCATION } from '../../utils/Constant';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spinner } from 'reactstrap';
import { fetchNotifications } from './NotificationsHelper';

interface INotificationPageProps {
  open: boolean;
  toggle: (param: boolean) => void;
}

const NotificationPage: React.FC<INotificationPageProps> = ({
  open,
  toggle,
}) => {
  const notificationTypes = useAppSelector(notificationSelector).types;
  const [notifications, setNotifications] = useState<NotificationType[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedType, setSelectedType] = useState(DEFAULT_OPTION_LOCATION);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const countPerPage = 20;

  useEffect(() => {
    if (open) {
      document.body.classList.add('notification-open');
    } else {
      document.body.classList.remove('notification-open');
    }

    return () => {
      document.body.classList.remove('notification-open');
    };
  }, [open]);

  const resetNotifications = () => {
    setNotifications([]);
    setPage(1);
    setHasMore(true);
  };

  useEffect(() => {
    dispatch(getTypes());
  }, []);

  useEffect(() => {
    resetNotifications();
    fetchNotifications([], 1, true, true, {
      loading,
      setLoading,
      dispatch,
      countPerPage,
      selectedType,
      setNotifications,
      setHasMore,
      setPage,
    });
  }, [selectedType]);

  return (
    <>
      <button className="overlay-notification" onClick={() => toggle(false)} />
      <div className="main">
        <div className="main-div">
          <Box p={1} className="notification-header">
            <Box display="flex" alignItems="center" gap={1}>
              <span className="notification-title">Notifications</span>
            </Box>
            <IconButton onClick={() => toggle(false)}>
              <CloseIcon color="error" />
            </IconButton>
          </Box>
          <hr className="m-0" />
          <div className="p-2 pb-0 display-flex flex-end">
            <SelectBox
              label={''}
              placeholder={'Select the module'}
              options={[DEFAULT_OPTION_LOCATION, ...(notificationTypes || [])]}
              className="css-select-bg"
              value={selectedType ?? DEFAULT_OPTION_LOCATION}
              onChange={setSelectedType}
              showClear={false}
            />
          </div>
          <div className="notification-body" id="scrollableDiv">
            <InfiniteScroll
              dataLength={notifications.length}
              next={() =>
                fetchNotifications(notifications, page, hasMore, false, {
                  loading,
                  setLoading,
                  dispatch,
                  countPerPage,
                  selectedType,
                  setNotifications,
                  setHasMore,
                  setPage,
                })
              }
              hasMore={hasMore}
              loader={
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: '100%' }}
                >
                  <Spinner>Loading...</Spinner>
                </div>
              }
              scrollableTarget="scrollableDiv"
            >
              {notifications?.length > 0 &&
                notifications.map((notification) => (
                  <Box
                    key={`notification-item-${notification.notificationHistoryId}`}
                    className="ps-3 pe-3 pt-2"
                  >
                    <div className="notification-title1">
                      {notification.notificationTitle}
                    </div>
                    <div className="notification-description">
                      {notification.notificationMessage}
                    </div>
                    <div className="notification-time">
                      {formattedDateWithFormat(
                        notification.createdOn,
                        'DD-MM-YYYY hh:mm A'
                      )}
                    </div>
                  </Box>
                ))}

              {!notifications?.length && !loading && (
                <div className="d-flex justify-content-center">
                  No notifications
                </div>
              )}
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationPage;
